import { ITranslationGroup } from '@d-id/types';
import { useRecoilValue } from 'recoil';
import { uploadingTranslationGroupsAtom } from './translationLibrary';

export const useAddLoadingTranslationGroups = () => {
    const uploadingTranslationGroups = useRecoilValue(uploadingTranslationGroupsAtom);

    const handleAddLoadingTranslationGroups = (groups: ITranslationGroup[]): ITranslationGroup[] => {
        if (!uploadingTranslationGroups.length) {
            return groups;
        }

        const mappedGroups = groups.map(group => group.id);

        const filteredUploadingTranslationGroups = [...uploadingTranslationGroups].filter(group => !mappedGroups.includes(group.id));

        const concatedGroups = [...groups, ...filteredUploadingTranslationGroups];

        const sorted = concatedGroups.sort((a, b) => (new Date(a.created_at).getTime() > new Date(b.created_at).getTime() ? -1 : 1));
        return sorted;
    };

    return { addLoadingGroups: handleAddLoadingTranslationGroups };
};
